import { __extends, __rest } from "tslib";
import { Misc } from "@singularsystems/neo-core";
import React from "react";
import { NeoReactTypes } from "../..";
/** Renders an icon using the icon factory specified at startup. */
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Icon.prototype, "iconFactory", {
        get: function () {
            if (!Icon._iconFactory) {
                Icon._iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
            }
            return Icon._iconFactory;
        },
        enumerable: false,
        configurable: true
    });
    Icon.prototype.render = function () {
        var _a = this.props, name = _a.name, factory = _a.factory, iconStyle = __rest(_a, ["name", "factory"]);
        return (factory !== null && factory !== void 0 ? factory : this.iconFactory).getIconComponent(name, iconStyle);
    };
    return Icon;
}(React.Component));
export default Icon;
